module.exports = __webpack_public_path__ + "img/tsdo-logo.6dd9ae53.png";